// test1486
(1486 && 0);
